<template>
    <el-dialog :visible.sync="openDialog" :append-to-body="true" class="newDialog" width="600px" title="审核" :close-on-click-modal="false">
        <el-form label-width="100px" ref="form" :model="form" :rules="rules" size="small">
            <el-form-item label="审核结果" prop="status">
                <el-radio-group v-model="form.status">
                    <el-radio :label="2">通过</el-radio>
                    <el-radio :label="3">驳回</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="供应商状态" prop="gysType" v-if="form.status == 2">
                <el-select v-model="form.gysType" style="width: 100%" size="small" placeholder="请选择供应商状态">
                    <el-option label="合格供应" :value="1"></el-option>
                    <el-option label="潜在供应商" :value="2"></el-option>
                    <el-option label="不合格供应商" :value="3"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="供应商分类" prop="supplierClassificationId" v-if="form.status == 2">
                <treeselect
                    v-model="form.supplierClassificationId"
                    size="mini"
                    :show-count="true"
                    :options="optionMenus"
                    :normalizer="normalizer"
                    placeholder="请选择供应商分类"
                />
            </el-form-item>
            <el-form-item label="驳回原因" prop="rejectReason" v-if="form.status == 3">
                <el-input
                    type="textarea"
                    size="small"
                    :rows="2"
                    placeholder="请输入内容"
                    v-model="form.rejectReason">
                </el-input>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click="openDialog = false" size="small">取 消</el-button>
            <el-button type="primary" @click="submitAudit" size="small">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { supplierInfoList ,queryByParentId, auditBasicInfo} from '@/api/gysmng/index';
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
export default {
    props: [],
    components:{
        Treeselect
    },
    data() {
        return {
            // 审核
            openDialog:false,
            form:{
                id:'',
                status:2,
                gysType:1,
                rejectReason:'',
                supplierClassificationId:undefined,
            },
            rules:{
                rejectReason:[{ required: true, message: '请输入驳回原因', trigger: 'blur' }],
                supplierClassificationId:[{ required: true, message: '请选择供应商分类', trigger: 'blur' }]
            },
            optionMenus:[]
        };
    },
    computed: {

    },
    created() {

    },
    mounted() {

    },
    methods: {
        async getMenuData(callback){
            let _this = this;
            const { data: res } = await queryByParentId({});
            if (res.code == 0) {
                let nodes = res.data || [];
                if(callback){
                    callback(nodes)
                }
            }
        },
        normalizer(node) {
            //删除 数据的子集
            if (node.children && !node.children.length) {
                delete node.children;
            }
            return {
                id: node.id,
                //将name转换成必填的label键
                label: node.name,
                children: node.children
            };
        },
         /** 查询菜单下拉树结构 */
        getTreeselect() {
            let _this = this;
            _this.optionMenus = [];
            this.getMenuData((data)=>{
                let arr = [];
                if(data[0] && data[0].children){
                    arr = data[0].children
                }
                _this.optionMenus=arr;
            })
        },
        auditOpen(row){
            this.form={
                id:row.id,
                status:2,
                gysType:1,
                supplierClassificationId:undefined,
                reason:'',
            };
            if (this.$refs["form"] !== undefined) {
				this.$refs["form"].resetFields();
			}
            this.openDialog = true;
            this.getTreeselect()
        },
        submitAudit(){
            let _this = this;
			_this.$refs['form'].validate((valid) => {
                if (valid) {
                    auditBasicInfo(this.form).then((response)=>{
                         if (response.data.code === 0) {
                            _this.$success(response.data.msg);
                            _this.openDialog = false;
                            _this.$emit('callback',{type:'getList'})
                            // _this.getList();
                        }
                    })
                }
            })
        },
    },
};
</script>

<style lang="scss">

</style>
